import { r as o, c as l, h as t, H as n, g as r } from "./main-bb89b2f2.js";
import "vue";
const h = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.border{border-width:1px}.outline{outline-style:solid}:host{display:block}.texttoggleContainer{fill:var(--texttoggle-text-default);background-color:var(--texttoggle-surface-default);border:1px solid var(--texttoggle-stroke-default);color:var(--texttoggle-text-default);height:var(--component-size-big-uniform)}.texttoggleContainer.small{height:var(--component-size-small-uniform)}.texttoggleContainer.extraSmall{height:var(--component-size-extra-small-uniform)}.texttoggleContainer:focus-within:not(:hover,.texttoggleContainerDisabled,.suppressFocusStyle){border-radius:0;outline:2px solid var(--texttoggle-stroke-focus);outline-offset:-2px}.texttoggleContainer.texttoggleContainerDisabled{border:1px solid var(--texttoggle-stroke-disabled)}.pointer-events-none{pointer-events:none}.static{position:static}.flex{display:flex}.w-max{width:-moz-max-content;width:max-content}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.items-center{align-items:center}.p-1{padding:var(--spacing-1)}.py-\\[3px\\]{padding-bottom:3px;padding-top:3px}.py-\\[2px\\]{padding-bottom:2px;padding-top:2px}.blur{--tw-blur:blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.mt-\\[8px\\]{margin-top:8px}", d = h, c = class {
  /**
   * Propagate disabled state to items.
   */
  handleDisabled(e, s) {
    e !== s && this.queryAllItems().forEach((a) => {
      a.disabled = this.disabled;
    });
  }
  /**
   * Watch for changes on the value property.
   */
  valueWatcher(e) {
    e == null && console.warn("[PatternlibTexttoggle] Value is null/undefined. This should not happen. The component may not work as intended."), this.handleValueChange(e);
  }
  openTextToggle(e) {
    e.stopPropagation(), this.suppressFocusStyle || (this.suppressFocusStyle = !0, this.renderState = (/* @__PURE__ */ new Date()).getTime());
    const s = e.detail;
    this.disabled || (this.controlled || (this.value = s), this.change.emit({ value: s, name: this.name }));
  }
  /*
   * KeyDown and blur events are used to handle focus style.
   */
  onItemKeyDown() {
    this.suppressFocusStyle || (this.suppressFocusStyle = !0, this.renderState = (/* @__PURE__ */ new Date()).getTime());
  }
  onItemBlur() {
    this.suppressFocusStyle && (this.suppressFocusStyle = !1, this.renderState = (/* @__PURE__ */ new Date()).getTime());
  }
  constructor(e) {
    o(this, e), this.change = l(this, "lhChange", 7), this.suppressFocusStyle = !1, this.additionalInfo = "", this.additionalInfoPosition = "top", this.label = "", this.disabled = void 0, this.size = "big", this.name = "", this.status = "default", this.successText = "", this.errorText = "", this.warningText = "", this.usePlaceholderHeight = !1, this.controlled = !1, this.value = void 0, this.wcag = "", this.renderState = 0, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  /**
   * Sets the items active property based on the value property.
   */
  handleValueChange(e) {
    e != null ? this.queryAllItems().forEach((i) => i.active = i.value === e) : this.queryAllItems().forEach((i) => i.active = !1);
  }
  queryAllItems() {
    const e = this.hostElement.querySelectorAll("patternlib-texttoggle-item");
    return Array.from(e);
  }
  handleSlotChange() {
    this.handleDisabled(this.disabled);
  }
  componentWillLoad() {
    this.handleValueChange(this.value), this.handleDisabled(this.disabled), this.wcag === "AAA" && (this.size = "big");
  }
  componentWillRender() {
    this.queryAllItems().forEach((s) => {
      s.size = this.size, s.wcag = this.wcag;
    });
  }
  render() {
    const e = {
      texttoggleContainer: !0,
      "texttoggleContainerDisabled pointer-events-none": this.disabled,
      "w-max p-1 flex items-center select-none": !0,
      "py-[3px]": this.size === "small",
      // 40-2(border) - 32(item height) = 6px
      "py-[2px]": this.size === "extraSmall",
      // 24-2(border) - 18(item height) = 4px
      [this.size]: !0,
      // handle focus style deppending on item focus
      suppressFocusStyle: this.suppressFocusStyle
    }, s = this.hostElement.querySelector('[slot="error-message"]') != null, i = this.hostElement.querySelector('[slot="success-message"]') != null, a = this.hostElement.querySelector('[slot="warning-message"]') != null;
    return t(n, { key: "92406912866c8b70a6ef1bd38ea1e4d516cbc255" }, t("patternlib-form-group", { key: "cc8fcf34c028a477e85402488ac2469fbe23b033", status: this.status, additionalInfoPosition: this.additionalInfoPosition, usePlaceholderHeight: this.usePlaceholderHeight }, this.label == "" ? null : t("span", { slot: "label" }, this.label), this.additionalInfo == "" ? null : t("span", { slot: "additional-info" }, this.additionalInfo), t("div", { key: "f2ba5d50bc15bacd405fccfeac41673e14a59e6a", slot: "element", class: e, tabIndex: -1 }, t("slot", { key: "391c6bc0a6f000c750f63ecfd96d7d5a1a2c1463", onSlotchange: this.handleSlotChange })), this.successText !== "" && t("div", { key: "5554aa0bedda75f78c419fe156c46c63cf7a7bc8", slot: "success-message" }, this.successText), i && t("slot", { key: "8df9b66f1fa21f41888d80ba0d3e3dec19432fd2", name: "success-message", slot: "success-message" }), this.warningText !== "" && t("div", { key: "3510823aa4d4565c0568422cd3810eaa524d29e7", slot: "warning-message" }, this.warningText), a && t("slot", { key: "31bbe0c93ffe2443248e58cb65181975c076c552", name: "warning-message", slot: "warning-message" }), this.errorText !== "" && t("div", { key: "0f2442b9c28b89bbc207ada12bfa9f62bbb59a81", slot: "error-message" }, this.errorText), s && t("slot", { key: "8c16a0882ddd08171ee68edb00af0a6bfd1f5c79", name: "error-message", slot: "error-message" })));
  }
  get hostElement() {
    return r(this);
  }
  static get watchers() {
    return {
      disabled: ["handleDisabled"],
      value: ["valueWatcher"]
    };
  }
};
c.style = d;
export {
  c as patternlib_texttoggle
};
